@if (spinning$ | async) {
    <div class="spinner">
        <svg viewBox="0 0 60 60">
            <circle
                cx="30"
                cy="30"
                r="26"
                stroke="#00579d"
                stroke-width="8px"
                fill="none"
            />
        </svg>
    </div>
}
